'use client';
import { memo } from 'react';
import { Button } from '@chakra-ui/react';

import InterText from 'shared/InterText';
import { goTo } from 'shared/lib';

import { DEFAULT_TRANSITION, SECTIONS_IDS } from 'constants/global';

const ButtonGoTo = ({
  enableGoTo = true,
  elementToGo = SECTIONS_IDS.form,
  btnText = 'Стать лидером',
  textProps = null,
  onBtnClick = null,
  ...props
}) => (
  <Button
    h="unset"
    borderRadius="48px"
    p={{ mobile: '16px 40px', laptop: '22.5px 40px' }}
    color="deepBlue"
    bgColor="ourGreen"
    transition={DEFAULT_TRANSITION}
    _hover={{ bgColor: '#00A372', color: '#0F151C' }}
    onClick={() => {
      enableGoTo && goTo(elementToGo, { offset: -110 });
      onBtnClick && onBtnClick();
    }}
    {...props}
  >
    <InterText textStyle="b3" {...textProps}>
      {btnText}
    </InterText>
  </Button>
);

export default memo(ButtonGoTo);
